import React, { useEffect, useState } from "react";
import DTOCurrentSalaryEditModal from "./DTOCurrentSalaryEditModal";
import CurrentSalaryEditModalPresenter from "./CurrentSalaryEditModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import _ from "lodash";
import { salaryService } from "../../../../api/services/salaryService";
import { setEmployeeAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/allowanceSlice";
import { setEmployeeOtherAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/otherAllowanceSlice";
import {
  setPaymentMethod,
  setSalaryStartDate,
} from "../../../../infra/aggregates/myProfile/salaryAggregates/updatedSalaryDateSlice";
import { setPreviousEmployeeAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/previousAllowanceSlice";
import { setPreviousEmployeeOtherAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/previousOtherAllowanceSlice";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  allAllowancesData: any;
  allAdditionalBenefitsData: any;
  trans?: any;
}

const CurrentSalaryEditModalController = ({
  isModalOpen,
  closeModal,
  allAdditionalBenefitsData,
  allAllowancesData,
  trans,
}: ModalInterface) => {
  const getData = (data: any) => {
    updateSalary(data);
  };
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  const salary_data = useAppSelector((state) => state.updatedSalaryDateSlice);

  async function updateSalary(data: any) {
    if (data.all_allowances && data.all_benefits) {
      const payload = {
        emp_id: selector.emp_id,
        company_id: selector.company_id,
        apply_side_effect: true,
        allowance_context: data.all_allowances,
        other_allowance_context: data.all_benefits,
        start_date: data?.start_date,
        payment_method: data?.paymentMethod,
      };

      await salaryService
        .updateEmpSalary(payload)
        .then((response) => {
          if (response.response === "success") {
            const salaryAllowance: any = response?.data[0]?.salary_allowance;
            const prev_salary_allowance: any =
              response?.data[0]?.prev_salary_allowance;

            const additionalBenefits: any =
              response?.data[0]?.additional_benefits;
            const prev_other_allowance: any =
              response?.data[0]?.prev_other_allowance;
            dispatch(setEmployeeAllowance(salaryAllowance));
            dispatch(setEmployeeOtherAllowance(additionalBenefits));
            dispatch(setPreviousEmployeeAllowance(prev_salary_allowance));
            dispatch(setPreviousEmployeeOtherAllowance(prev_other_allowance));
            dispatch(setSalaryStartDate(response?.data[0]?.start_date));
            dispatch(setPaymentMethod(response?.data[0]?.payment_method));

            toast.success(trans("Salary Updated Successfully"));
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    } else {
      toast.error(trans("Invalid Data!"));
    }
  }

  return (
    <div>
      <DTOCurrentSalaryEditModal />
      <CurrentSalaryEditModalPresenter
        callBackData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allAllowancesData={allAllowancesData}
        allAdditionalBenefitsData={allAdditionalBenefitsData}
        paymentMethod={salary_data.paymentMethod}
        salaryStartDate={salary_data.start_date}
        trans={trans}
      />
    </div>
  );
};

export default CurrentSalaryEditModalController;
